export default {
  currentStep: state => state.currentStep,
  uuid: state => state.uuid,
  isEditing: state => state.isEditing,
  active: state => state.active,
  providerId: state => state.providerId,
  provider: state => state.provider,
  name: state => state.name,
  cod: state => state.cod,
  layout: state => state.layout
}
